import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavigationFooter from "../blocks/NavigationFooter.vue";
import TimeLine from "../blocks/TimeLine.vue";
import PageTitle from "../blocks/PageTitle.vue";
import TermsAndConditions from "@/components/blocks/TermsAndConditions.vue";
import ContentWrapper from "../generics/ContentWrapper.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTitle, {
      text: "Allmänna villkor",
      backgroundImageClass: "background-general-train"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TermsAndConditions)
      ]),
      _: 1
    })
  ], 64))
}
}

})